// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/footer/Footer.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/footer/Footer.tsx");
  import.meta.hot.lastModified = "1725370006827.4065";
}
// REMIX HMR END

import { useNavigation } from "@remix-run/react";
export default function Footer() {
  _s();
  const {
    state
  } = useNavigation();
  return <footer className="ftr">
            {/**
             *       
             */}
      {state === 'loading' ? <div className="logo spinner" /> : null}


        </footer>;
}
_s(Footer, "lsd5jGwSemzACbH3Vtd0SWBB0ss=", false, function () {
  return [useNavigation];
});
_c = Footer;
var _c;
$RefreshReg$(_c, "Footer");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;